import React, { Component } from 'react'
import PropTypes from 'prop-types'
import * as R from 'ramda'
import { indexMap } from '@helpers'
import Link from 'gatsby-link'

class Navigation extends Component {
  renderSubmenu (item) {
    const { allowSubmenu } = this.props
    const { subMenu } = item

    if (allowSubmenu && subMenu) {
      return (
        <ul>
          <li>Hi</li>
        </ul>
      )
    }
  }

  renderLink = (links) => indexMap((item, index) => {
    const { click } = this.props
    const slug = R.pathOr('', ['link', 'slug'], item)
    const title = R.prop('title', item)
    const externalLink = R.prop('externalLink', item)
    return (
      <li key={`${slug}-${index}`}>
        {externalLink ? <a href={externalLink} target='_blank' rel='noopener noreferrer'>{R.prop('title', item)}</a>
          : <Link to={`/${slug}`} onClick={() => click()}>{title}</Link> }
        {this.renderSubmenu(item)}
      </li>
    )
  }, links)

  render () {
    const { links } = this.props
    return (
      <nav>
        <ul>
          {this.renderLink(links)}
        </ul>
      </nav>
    )
  }
}

Navigation.propTypes = {
  links: PropTypes.array,
  click: PropTypes.func
}

Navigation.defaultProps = {
  links: [],
  click: () => {}
}

export default Navigation



// WEBPACK FOOTER //
// ./src/components/Navigation/Navigation.js